module.exports = __webpack_public_path__ + "static/content-2-a7155f7e86a82b45c6b79a9602109155.png";